import React from 'react';
import FranchiseHub from '../components/FranchiseHub';

const FranchisePage = () => {
  return (
    <div className="gfi-franchise-page-wrapper">
      
      {/* MASTER FRANCHISE HUB CONTAINER WITH EMBEDDED CAPTURE DECK */}
      <FranchiseHub />

    </div>
  );
};

export default FranchisePage;